import { RoutePath, type RoutePaths } from "@/lib/routes"

export const storyblokRoutesPaths = {
    agreementHealthExplanation: RoutePath.create("/bien-comprendre-la-sante-de-mon-contrat"),
    blog: RoutePath.create("/blog"),
    blogArticle: RoutePath.create("/blog/:articleId"),
    blogB2B: RoutePath.create("/blog-entreprises-collectivites"),
    contact: RoutePath.create("/contact"),
    customerFeedbackSuccess: RoutePath.create("/satisfaction-client/succes"),
    drivePack: RoutePath.create("/octopus-drive-pack"),
    ecoSessionWinterTips: RoutePath.create("/eco-sessions"),
    ecoSessionSummerTips: RoutePath.create("/eco-sessions-ete"),
    ecoSessionFAQ: RoutePath.create("/eco-sessions#es-question1-calcul"),
    ecoSessionResults: RoutePath.create("/eco-sessions-resultats"),
    electricVehicles: RoutePath.create("/vehicules-electriques"),
    electricityGasOffer: RoutePath.create("/offre-electricite-gaz"),
    electricityMoveIn: RoutePath.create("/demenagement-electricite"),
    electricityOfferPricing: RoutePath.create("/offre-electricite-tarifs"),
    electricitySupplier: RoutePath.create("/fournisseur-electricite"),
    exSupplierOffer: RoutePath.create("/oublier-mon-ex"),
    exSupplierOfferForCustomer: RoutePath.create("/partage-oublier-son-ex"),
    fanClub: RoutePath.create("/fan-club"),
    faq: RoutePath.create("/aide-faq"),
    faqArticle: RoutePath.create("/aide-faq/:articleId"),
    faqBusiness: RoutePath.create("/aide-faq-entreprises-collectivites"),
    faqBusinessArticle: RoutePath.create("/aide-faq-entreprises-collectivites/:articleId"),
    greenEnergy: RoutePath.create("/energie-verte"),
    home: RoutePath.create("/"),
    intelligentOctopus: RoutePath.create("/intelligent-octopus"),
    landing: RoutePath.create("/:landingId"),
    legal: RoutePath.create("/legal"),
    legalPage: RoutePath.create("/legal/:pageId"),
    octopusGo: RoutePath.create("/offre-electricite-voiture"),
    offer: RoutePath.create("/offre"),
    pressArea: RoutePath.create("/espace-presse"),
    privacyPolicy: RoutePath.create("/legal/politique-confidentialite-oef"),
    referral: RoutePath.create("/parrainage"),
    regional: RoutePath.create("/collectivites"),
    solarPanels: RoutePath.create("/panneaux-solaires"),
    solarPhotovoltaicPanels: RoutePath.create("/panneaux-solaires-photovoltaiques"),
    tariffs: RoutePath.create("/offre"),
} as const satisfies RoutePaths
